import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useMedicareUrl } from 'hooks/useMedicareUrl'
import { RelatedResources as RelatedResourcesCommon, RelatedResourcesProps } from 'components/RelatedResources/RelatedResources'
import { CLAIMS_URLS_ENGLISH, CLAIMS_URLS_SPANISH } from '../urls'

export const RelatedResources: FC = () => {
  const { t } = useTranslation('claimsSearch', { keyPrefix: 'relatedResources' })
  const props: RelatedResourcesProps = {
    heading: t('heading'),
    lists: [
      {
        heading: t('claimsHeading'),
        links: [
          {
            text: t('fileAClaimLinkText'),
            url: useMedicareUrl(
              CLAIMS_URLS_ENGLISH.howToFileAClaim,
              CLAIMS_URLS_SPANISH.howToFileAClaim
            ),
            openInNewWindow: true
          },
          {
            text: t('fileAComplaintLinkText'),
            url: useMedicareUrl(
              CLAIMS_URLS_ENGLISH.howToFileAComplaint,
              CLAIMS_URLS_SPANISH.howToFileAComplaint
            ),
            openInNewWindow: true
          },
          {
            text: t('whatIsAnMsnLinkText'),
            url: useMedicareUrl(
              CLAIMS_URLS_ENGLISH.formsHelpMsn,
              CLAIMS_URLS_SPANISH.formsHelpMsn
            ),
            openInNewWindow: true
          },
          {
            text: t('learnHowToSpotFraudLinkText'),
            url: useMedicareUrl(
              CLAIMS_URLS_ENGLISH.howToSpotFraud,
              CLAIMS_URLS_SPANISH.howToSpotFraud
            ),
            openInNewWindow: true
          }
        ]
      },
      {
        heading: t('appealsHeading'),
        links: [
          {
            text: t('fileAnAppealLinkText'),
            url: useMedicareUrl(
              CLAIMS_URLS_ENGLISH.howToFileAnAppeal,
              CLAIMS_URLS_SPANISH.howToFileAnAppeal
            )
          },
          {
            text: t('fiveThingsToKnowWhenFilingAnAppealLinkText'),
            url: useMedicareUrl(
              CLAIMS_URLS_ENGLISH.fiveThingsToKnowWhenFilingAnAppeal,
              CLAIMS_URLS_SPANISH.fiveThingsToKnowWhenFilingAnAppeal
            )
          },
          {
            text: t('getHelpFilingAnAppealLinkText'),
            url: useMedicareUrl(
              CLAIMS_URLS_ENGLISH.canSomeoneFileAnAppealForMe,
              CLAIMS_URLS_SPANISH.canSomeoneFileAnAppealForMe
            )
          }
        ]
      },
      {
        heading: t('costsHeading'),
        links: [
          {
            text: t('isMyTestItemOrServiceCoveredLinkText'),
            url: useMedicareUrl(
              CLAIMS_URLS_ENGLISH.coverage,
              CLAIMS_URLS_SPANISH.coverage
            )
          },
          {
            text: t('getHelpPayingCostsLinkText'),
            url: useMedicareUrl(
              CLAIMS_URLS_ENGLISH.getHelpPayingCosts,
              CLAIMS_URLS_SPANISH.getHelpPayingCosts
            )
          },
          {
            text: t('costsAtAGlanceLinkText'),
            url: useMedicareUrl(
              CLAIMS_URLS_ENGLISH.costsAtAGlance,
              CLAIMS_URLS_SPANISH.costsAtAGlance
            )
          },
          {
            text: t('howOriginalMedicareWorksLinkText'),
            url: useMedicareUrl(
              CLAIMS_URLS_ENGLISH.howOriginalMedicareWorks,
              CLAIMS_URLS_SPANISH.howOriginalMedicareWorks
            )
          }
        ]
      }
    ]
  }

  return (
    <RelatedResourcesCommon {...props} />
  )
}
